<template>
  <div class="info-detail">
    <div class="info-title fs-xl">
      <div class="changeline" v-if="routeData.one == '校园群体'">{{ articleInfo.name }} {{ articleInfo.title }}</div>
      <div class="changeline" v-else-if="routeData.one == '体育场馆'">
        {{ articleInfo.venueName }}
      </div>
      <div class="changeline" v-else>
        {{ articleInfo.title }}
      </div>
    </div>
    <div class="info-date fs-sm" v-if="routeData.one == '校园群体'">
      <span v-if="routeData.two == '竞赛规程'">总规程时间：{{ articleInfo.publishDate }}</span>
      <span v-else>活动时间：{{ articleInfo.publishDate }}</span>
    </div>
    <div class="info-date fs-sm" v-else-if="routeData.one == '体育场馆'">
      <!-- 体育场馆 -->
    </div>
    <div class="info-date fs-sm d-aligncnter d-center" v-else>
      <span>发布日期：{{ articleInfo.publishDate }}</span>
      <span class="source" v-if="articleInfo.newsSources != ''">信息来源：{{ articleInfo.newsSources }}</span>
      <span class="click d-aligncnter">
        <img :src="img" style="margin-right: 8px; margin-top: 2px" />{{ articleInfo.clicks }}
      </span>
    </div>

    <!-- <div class="info-article content-jshd" v-if="routeData.two == '竞赛活动'">
      <div>竞赛报名时间：{{ articleInfo.signUpTime }}</div>
      <div>竞赛活动时间：{{ articleInfo.raceTime }}</div>
      <div>活动具体项目：</div>
      <div v-for="(item, index) in articleInfo.resList" :key="index">
        {{ item.name }} - {{ item.gender }} - {{ item.raceType }} -
        {{ item.type }}
      </div>
    </div> -->
    <div class="info-article content-jshd" v-if="routeData.two == '场馆介绍'">
      <div class="d-aligncnter">
        <div class="item-logo"></div>
        <div class="item-title weight fs-lg">场馆简介</div>
      </div>
      <div class="info-article" v-html="articleInfo.content" style="min-height: 100px"></div>
      <div class="d-aligncnter">
        <div class="item-logo"></div>
        <div class="item-title weight fs-lg">场馆风貌</div>
      </div>
      <div class="d-center" v-if="articleInfo.coverFile != null">
        <img :src="articleInfo.coverFile.path" @error="headError" style="max-width: 1100px" />
      </div>
    </div>
    <div class="info-article" v-else v-html="articleInfo.content"></div>
    <div
      class="info-source overflow"
      v-if="
        articleInfo.author != '' &&
        articleInfo.photographer != '' &&
        routeData.one != '校园群体' &&
        routeData.one != '体育场馆'
      "
    >
      文：{{ articleInfo.author }}&nbsp;&nbsp;&nbsp;摄影：{{ articleInfo.photographer }}
    </div>
    <div class="changeArticle j-flex" style="display: none">
      <div class="overflow" title="">上一篇：浙大城市学院第十八届田径运动会落幕</div>
      <div class="overflow next" title="">下一篇：聚焦问题、加强谋划、务求实效、推进</div>
    </div>
    <div v-if="articleInfo.ruleFileList && articleInfo.ruleFileList.length > 0" class="down">
      <div style="font-weight: bold">文章附件如下:</div>
      <div v-for="(item, index) in articleInfo.ruleFileList" :key="'fj_' + index" class="div-a">
        <a target="_blank" :href="item.path">{{ index + 1 }}、{{ item.name }}</a>
      </div>
    </div>
  </div>
</template>
<script>
import { formateDate } from '@/assets/js/date'
import { getRaceRuleDetail, getRaceDetail, getArticleDetail, addClicks } from '@/api/api.js'
import { getVenueInfo } from '@/api/api-venue'
export default {
  data() {
    return {
      type: '',
      img: require('@/assets/img/eye-open.svg'),
      articleInfo: {
        // title: '青春激扬，活力无限！奔跑吧！城院的运动健儿们！',
        // publishDate: '2019-10-25 13:18',
        // newsSources: '党委宣传部',
        // content:
        //   '10月25日上午，晴空万里，秋高气爽，浙江大学城市学院第十八届田径运动会在南校区操场拉开帷幕。学院院长韦巍宣布运动会开幕，党委书记吴健致开幕词，党委副书记赵阳主持开幕式。在众人的注视和期待下，国旗手、院旗手、红旗手迎着朝阳，迈着铿锵的步伐走向主席台。随后，各学院的代表方阵陆续入场，同学们带着明媚笑容，步履从容，意气风发，各个学院用他们独具特色的表演展现了城院学子英姿飒爽的青春、活力与自信。 习近平总书记在全国教育大会上强调，要以凝聚人心、完善人格、开发人力、培育人才、造福人民为工作目标，培育德智体美劳全面发展的社会主义建设者和接班人，并提出，要树立健康第一的教育理念，开齐开足体育课，帮助学生在体育锻炼中享受乐趣、增强体质、健全人格、锤炼意志。为贯彻落实这一精神，学院积极推进体育工作，进一步提高师生体质健康水平，在2019年浙江省高校学生体质健康抽测工作中，学院共有200名学生参与抽测，合格率达94.5%，位列全省本科院校第八，开幕式上，学院特授予工程学院和外语学院体质测试工作突出贡献奖。',
        // author: '刘嘉慧,毛怡',
        // photographer: '刘畅,郑焱隆,赖珥韶,章佳晨,孙芊芊,邓漠鹏,徐婧茹,王飞晔',
        // routeData: '',
      },
    }
  },
  created() {
    this.routeData = this.$route.query
    if (this.$route.query.three != '') {
      this.type = this.$route.query.three
    } else {
      this.type = this.$route.query.two
    }
    this.getArticleContent()
  },
  methods: {
    headError(e) {
      e.target.src = require('@/assets/img/clubdefault.png')
    },
    getArticleContent() {
      const that = this
      if (this.type == '竞赛规程') {
        getRaceRuleDetail(that.routeData.articleId).then((res) => {
          that.articleInfo = res.data.obj
          that.articleInfo.publishDate = res.data.obj.raceTime
        })
      } else if (this.type == '竞赛活动') {
        getRaceDetail(that.routeData.articleId).then((res) => {
          that.articleInfo = res.data.obj
          that.articleInfo.publishDate = res.data.obj.date
        })
      } else if (this.type == '场馆介绍') {
        getVenueInfo(that.routeData.articleId).then((res) => {
          that.articleInfo = res.data.obj
          //   that.articleInfo.publishDate = res.data.obj.date
        })
      } else {
        getArticleDetail(that.routeData.articleId).then((res) => {
          if (res.data.statusCode == 1) {
            // that.articleInfo.title = res.data.obj.title
            // that.articleInfo.source = res.data.obj.author
            //   res.data.obj.content = res.data.obj.content.replace(
            //     /\/uploadBase/g,
            //     'http://10.66.22.117:89' + '/uploadBase'
            //   )
            that.articleInfo = res.data.obj
            let date = new Date(res.data.obj.publishDate)
            that.articleInfo.publishDate = formateDate(date, 'yyyy-MM-dd hh:mm')
            addClicks(that.routeData.articleId).then((res) => {
              if (res.data.statusCode == 1) {
                that.articleInfo.clicks = res.data.obj.clicks
              }
            })
          }
        })
      }
    },
    downloadFile(item) {
      window.location.href = item.url
    },
    down() {
      window.location.href =
        'http://imtt.dd.qq.com/16891/26747DD8B125A8479AD0C9D22CA47BC9.apk?fsname=com.snda.wifilocating_4.2.91_3211.apk&csr=1bbd'
    },
  },
}
</script>
<style lang="scss" scoped>
.info-title {
  width: 100%;
  min-height: 68px;
  background: #e8e8e8;
  color: #181818;
  font-weight: 500;
  .changeline {
    text-align: center;
    width: calc(100% - 200px);
    margin-left: 100px;
    padding: 24px 0;
  }
}
.info-date {
  color: #5d5d5d;
  width: calc(100% - 36px);
  padding: 18px;
  text-align: center;
  .source {
    margin-left: 24px;
  }
}
.info-article {
  width: 100%;
  margin-top: 16px;
  color: #2f2f2f;
  margin-bottom: 24px;
  min-height: calc(100vh - 440px);
}
.info-source {
  width: calc(100% - 16px);
  height: 18px;
  padding: 8px;
  text-align: center;
  background: #f9f9f9;
  margin-bottom: 42px;
}
.changeArticle {
  margin-bottom: 32px;
  //   margin-top: 42px;
  cursor: pointer;
  div {
    width: 300px;
  }
  .next {
    text-align: right;
  }
  &:hover {
    color: #007a4d;
  }
}
.content-jshd {
  div {
    line-height: 40px;
  }
}
.item-logo {
  width: 4px;
  height: 25px;
  background: #80bca6;
  border-radius: 3px;
}
.item-title {
  line-height: 25px;
  color: #2f2f2f;
  margin-left: 10px;
}
.click {
  text-align: right;
  padding: 18px;
  padding-top: 16px;
}
.down {
  cursor: pointer;
  border-top: 1px solid #ededed;
  padding: 16px 32px 32px 32px;
  margin-top: 32px;
  //   margin-bottom: 48px;
  //   margin-left: 16px;
  .div-a {
    margin-top: 8px;
    margin-left: 32px;
  }
  a {
    text-decoration: none;
    color: #181818;
  }
}
.info-article ::v-deep img {
  max-width: 1100px !important;
}
</style>
